<h2 mat-dialog-title>Unsaved changes</h2>

<div mat-dialog-content>
  {{ 'UNSAVED_CHANGES_CONFIRM' | translate }}
</div>

<div mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="close()">Cancel</button>
  <button mat-raised-button color="warn" (click)="close({ navigateAwayAndDiscard: true })">Discard and close</button>
</div>
